export { default } from '@esentai/core/features/productCategory/api';
